import React from 'react';

import {
  PartnerProfileProvider,
  useNotify,
  useRouter,
} from 'app/developer-v3/hooks';
import { getEmbedUrl } from 'app/developer-v3/utils';

import PoweredByZapierTos from './PoweredByZapierTos';

export default function Container() {
  const {
    params: { id },
    routeTo,
  } = useRouter();
  const notify = useNotify();

  return (
    <PartnerProfileProvider
      optionsMutation={{
        onSuccess: () =>
          notify.success(
            'You’re all set! You’ve accepted the Powered by Zapier Terms.'
          ),
      }}
    >
      <PoweredByZapierTos onClose={() => routeTo(getEmbedUrl(id))} />;
    </PartnerProfileProvider>
  );
}
